import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import TKgiayvantai from "components/Thongke/Giayvantai/TKgiayvantai.js";
export default function Tkbenxe() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Báo cáo giấy vận tải",
            tabContent: <TKgiayvantai />,
          },
        ]}
      />
    </div>
  );
}
